export default __webpack_public_path__ + "static/project-slide-7-992-765-f8dc695278e5fad67252b32b5edfa1e2.jpg";